import React from 'react';
import { Container, Card, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Roles = () => {
  return (
    <Container className="mt-4">
      <Row className="mb-4">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2>Role Management</h2>
              <p className="text-muted">Manage user roles and permissions</p>
            </div>
            <Button as={Link} to="/admin" variant="outline-primary">
              ← Back to Dashboard
            </Button>
          </div>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="coming-soon-card">
            <div className="icon">
              <i className="bi bi-person-gear"></i>
            </div>
            <h3>Coming Soon</h3>
            <p className="text-muted mb-4">
              The Role Management feature is currently under development. 
              You'll be able to create, edit, and manage user roles with 
              granular permissions.
            </p>
            <div className="bg-light p-3 rounded mb-3">
              <h6>Planned Features:</h6>
              <ul className="list-unstyled">
                <li>✓ Custom role creation</li>
                <li>✓ Permission-based access control</li>
                <li>✓ Role assignment to users</li>
                <li>✓ Audit logs for role changes</li>
              </ul>
            </div>
            <Button variant="primary" disabled>
              Notify Me When Ready
            </Button>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Roles;